import React from 'react';

import { DatePicker, DateValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';
import { Grid, Toolbar } from '@mui/material';
import { RouteStopListRequest } from '../../../apis/serviceHistoryApi';

interface ServiceHistoryFilterBarProps {
  rowFilter: RouteStopListRequest;
  onFilterChanged: (rowFilter: RouteStopListRequest) => void;
}

function ServiceHistoryFilterBar({ rowFilter, onFilterChanged }: ServiceHistoryFilterBarProps) {
  const minDate = new Date(2010, 0, 2);
  const [fromDateError, setFromDateError] = React.useState<string | null>(null);
  const [toDateError, setToDateError] = React.useState<string | null>(null);
  const formIsValid = React.useRef(true);

  const handleTableFilter = async (ctx: PickerChangeHandlerContext<DateValidationError>, filter: Partial<RouteStopListRequest>) => {
    const newFilter = { ...rowFilter, ...filter };
    const isValid =
      !ctx.validationError &&
      newFilter.fromDate >= minDate &&
      newFilter.fromDate <= newFilter.toDate &&
      newFilter.fromDate <= new Date() &&
      newFilter.toDate >= minDate;

    formIsValid.current = isValid;
    if (isValid) {
      onFilterChanged(newFilter);
    }
  };

  const getDateError = (error: DateValidationError, controlName?: string) => {
    if (error === 'disableFuture') {
      return 'Cannot be future date';
    }
    if (error === 'minDate') {
      if (controlName === 'toDate') {
        return 'Cannot be less than From date';
      }
      return 'Must be greater than 01/01/2010';
    }
    if (error === 'invalidDate') {
      return 'Date is not valid';
    }
    return null;
  };

  return (
    <Toolbar>
      <Grid sx={{ mb: 1, mt: 1 }}>
        <DatePicker
          sx={{ ml: 1, mr: 3, mt: 5, width: { xs: 140, sm: 200 } }}
          slotProps={{
            textField: {
              size: 'small',
              helperText: fromDateError,
              error: !!fromDateError,
              FormHelperTextProps: { sx: { marginLeft: 1, marginInlineStart: 1 } },
            },
          }}
          label="From date"
          value={rowFilter.fromDate}
          minDate={minDate}
          disableFuture={true}
          onError={(error) => {
            setFromDateError(getDateError(error));
          }}
          onChange={(val, ctx) => {
            handleTableFilter(ctx, { fromDate: val as Date });
          }}
        />
        <DatePicker
          sx={{ ml: 1, mt: 5, width: { xs: 140, sm: 200 } }}
          slotProps={{
            textField: {
              size: 'small',
              helperText: toDateError,
              error: !!toDateError,
              FormHelperTextProps: { sx: { marginLeft: 1, marginInlineStart: 1 } },
            },
          }}
          label="To date"
          value={rowFilter.toDate}
          minDate={rowFilter.fromDate ?? minDate}
          onError={(error) => {
            setToDateError(getDateError(error, 'toDate'));
          }}
          onChange={(val, ctx) => {
            handleTableFilter(ctx, { toDate: val as Date });
          }}
        />
      </Grid>
    </Toolbar>
  );
}

export default ServiceHistoryFilterBar;
